export default {
  default: () => import("/usr/src/app/layouts/default.vue").then(m => m.default || m),
  home: () => import("/usr/src/app/layouts/home.vue").then(m => m.default || m),
  "layout-01": () => import("/usr/src/app/layouts/layout-01.vue").then(m => m.default || m),
  "layout-02": () => import("/usr/src/app/layouts/layout-02.vue").then(m => m.default || m),
  "layout-03": () => import("/usr/src/app/layouts/layout-03.vue").then(m => m.default || m)
}